module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_dress-ac648b6471ecbde69e4f283fc72f62ca.jpg";